import * as ContactActions   from '../contacts/actions';
import * as ContactSelectors from '../contacts/selectors';
import { connect }           from 'react-redux';
import { useEffect }         from 'react';
import FetchFromServer       from '../components/fetch_from_server';
import React                 from 'react';
import WaitFor               from '../components/wait_for';


export default connect(
  (state, { businessID, contactID }) => ({
    businessID,
    contactID,
    contact:  ContactSelectors.getContact(state, contactID),
    statuses: ContactSelectors.getContactStatuses(state, contactID)
  }),
  (dispatch, { businessID, contactID, navigateTo }) => ({
    load: () => dispatch(ContactActions.readContact(contactID, businessID)),
    navigateTo
  })
)(RedirectToInboxPage);


export function RedirectToInboxPage({ businessID, contact, load, navigateTo, statuses }) {
  const conversationID = contact?.conversation?.id;

  return (
    <FetchFromServer statuses={statuses} load={load}>
      <WaitFor {...{ statuses }}>
        {conversationID && <Redirect {...{ businessID, conversationID, navigateTo }}/>}
      </WaitFor>
    </FetchFromServer>
  );
}


function Redirect({ businessID, conversationID, navigateTo }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      // Wait for page load before redirecting, see
      // https://github.com/broadly/broadly/issues/4234
      navigateTo(`/${businessID}/inbox/${conversationID}`, { reloadCurrent: true });
    }, 750);

    return () => clearTimeout(timer);
  }, [ conversationID, businessID, navigateTo ]);

  return null;
}
